import angular from 'angular';

import AdverseEventsService from 'services/adverse-events.service';
import AlertService from 'services/alert.service';
import AnimalTypeService from 'services/animal-type.service';
import ArrayService from 'services/array.service';
import AuthService from 'services/auth.service';
import CategoryService from 'services/category.service';
import CompanyService from 'services/company.service';
import IngredientService from 'services/ingredient.service';
import FeedbackService from 'services//feedback.service';
import LoadingService from 'services/loading.service';
import PeopleService from 'services/people.service';
import ProductService from 'services/product.service';
import RegulatorService from 'services/regulator.service';
import ReportService from 'services/report.service';
import SessionService from 'services/session.service';
import ToastService from 'services/toast.service';
import UsageDataService from 'services/usage-data.service';

import directives from './directives/directives.module';

export default angular.module('common', [
  directives
])
  .service('AdverseEventsService', AdverseEventsService)
  .service('AnimalTypeService', AnimalTypeService)
  .service('AlertService', AlertService)
  .service('ArrayService', ArrayService)
  .service('AuthService', AuthService)
  .service('CategoryService', CategoryService)
  .service('CompanyService', CompanyService)
  .service('FeedbackService', FeedbackService)
  .service('IngredientService', IngredientService)
  .service('LoadingService', LoadingService)
  .service('PeopleService', PeopleService)
  .service('ProductService', ProductService)
  .service('RegulatorService', RegulatorService)
  .service('ReportService', ReportService)
  .service('SessionService', SessionService)
  .service('ToastService', ToastService)
  .service('UsageDataService', UsageDataService)
  .name;



// WEBPACK FOOTER //
// ./common/common.module.js